var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-center"},[_c('md-progress-spinner',{staticClass:"md-accent",attrs:{"md-stroke":3,"md-mode":"indeterminate"}}),_c('br'),_vm._v(" "+_vm._s(_vm.texto)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }